function generateData(data, layout) {
    const calcedData = [];

    for (let r = 0; r < layout.rows.length; ++r) {
        let row = layout.rows[r];
        let colsArray = [];
        calcedData.push(colsArray);
        for (let c = 0; c < row.columns.length; ++c) {
            let cell = row.columns[c];
            let val = null;
            if (cell && cell.arrayIndex !== null && typeof cell.arrayIndex !== 'undefined') {
                val = data ? data[cell.attributeName][cell.arrayIndex] : "";
            } else {
                val = data ? data[cell?.attributeName ?? ""] : "";
            }
            colsArray.push(val);// empty here to handle empty column
        }
    }
    return calcedData;
}

function makeRows(items, columnCount) {
    let pos = [];
    let parts = [];
    let nextStart = 0;
    let thisStart = 0;

    let totalItems = items.length;
    let partSize = Math.ceil(totalItems / columnCount);

    let itemPos = 0;

    for (let col = 0; col < columnCount; ++col) {
        parts[col] = [];
        thisStart = col * partSize;
        for (let i = 0; i < partSize; ++i) {
            var addItem = true;
            if (col > 0) {
                let prevCol = col - 1;
                let prevItem = parts[prevCol][i];
                if (prevItem == null || prevItem.lastColumn) {
                    parts[col].push(null);
                    addItem = false;
                }
            }
            if (addItem) {
                if (itemPos >= items.length) {
                    parts[col].push(null);
                } else {
                    let item = items[itemPos++];
                    parts[col].push(item);

                    if (item.lastColumn) {
                        totalItems += columnCount - col - 1; // increase the number of parts to take into account added nulls
                                                            // one for each column after this
                        partSize = Math.ceil(totalItems / columnCount);
                    }
                }
            }
        }

        // Fill in any left overs if we have come up short
        if (col > 0) {
            for (let fillIn = 0; fillIn < (parts[col - 1].length - parts[col].length); ++fillIn) {
                parts[col].push(null);
            }
        }
    }

    let widthPerCol = (columnCount > 0) ? Math.round(12 / columnCount) : 0; 
    let rows = [];

    for (let i = 0; i < partSize; i++) {
        let columns = [];
        for (let j = 0; j < columnCount; ++j) {
            let part = parts[j][i];
            if (part != null) {
                part.width = widthPerCol;
            }
            columns.push(part || null);
        }

        rows.push({
            columns: columns
        });
    }

    return rows;
}

function makeTripleDotsMenu(rowData, id, functionToCall) {
    return `<button id="admissionButtonId-${id}"
                type="button"
                class="btn outline icon-button pull-right context-button"
                onclick="${functionToCall}(event, ${rowData}, ${id})">
                <i class="icon icon-dots-vertical IconAsButton"></i>
                </button>`;
}


export {
    generateData,
    makeRows,
    makeTripleDotsMenu
};
